import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';

import { COLOR_PRIMARY_1 } from '../../../vars';

import { selectConfig } from '../../Api/selectors';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import styles from './CardTransporterInfo.module.css';
import cn from 'classnames';

const Container = styled.div`
  font-size: 12px;

  .cardHeader {
    margin-bottom: 20px;
  }
  .card-title {
    white-space: nowrap;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  input {
    width: 100%;
  }

  .row-input {
    .col-1 {
      flex-basis: 25%;
      margin-right: 5px;
    }
    .col-2 {
      flex-basis: 57%;
    }
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }

  .link-wrap {
    cursor: pointer;
    &:hover {
      color: ${COLOR_PRIMARY_1};
    }
  }
`;

const STATE = {
  isEditCompany: false,
};
/* eslint-disable react/prefer-stateless-function */
class TransporterInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  checkbox(type, label) {
    return <CheckboxComponent label={label} checked={this.state[type] == '1'} />;
  }

  isShowPropertyCell(type) {
    if (this.props.transporter?.[type]) {
      return true;
    }
    return false;
  }

  windowOpen(url, name, specs) {
    if (!url.match(/^https?:\/\//i)) {
      url = 'http://' + url;
    }
    return window.open(url);
  }

  rows(transporter) {
    return ['name', 'surname', 'phoneNumber', 'email', 'remarks'];
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    const transporter = this.props.transporter;

    return (
      <Card className="company-info-card info-card data">
        <Container className="cardHeader">
          <HBox className="align-items-center">
            <h2 className="card-title m-0">{this.lbl('transporter.info.data.transporter_info')}</h2>
          </HBox>

          <>
            {this.rows().map(property => {
              if (property == 'name') {
                return (
                  this.isShowPropertyCell(property) && (
                    <>
                      <div className={styles.containerLabel} key={property}>
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                          <div className={styles.labelTable}>{transporter?.['name'] ?? ''}</div>
                        </div>
                      </div>
                    </>
                  )
                );
              }
              if (property == 'surname') {
                return (
                  this.isShowPropertyCell(property) && (
                    <>
                      <div className={styles.containerLabel} key={property}>
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                          <div className={styles.labelTable}>{transporter?.['surname'] ?? ''}</div>
                        </div>
                      </div>
                    </>
                  )
                );
              }

              if (property == 'phoneNumber') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                        <div className={styles.labelTable}>{transporter?.['phoneNumber']}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'email') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                        <div className={styles.labelTable}>{transporter?.[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              //

              return (
                this.isShowPropertyCell(property) && (
                  <div className={styles.containerLabel} key={property}>
                    <div className={styles.formField}>
                      <div className={styles.textContainer}>{this.lbl(`transporter.property.${property}`)}</div>
                      <div className={styles.labelTable}>
                        {this.lbl(`transporter.property.${property}.${transporter?.[property]}`)}
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </>
        </Container>
      </Card>
    );
  }
}

TransporterInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransporterInfoCard = compose(withConnect, withRouter)(TransporterInfoCardComp);
